import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
}
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  onLinkClick,
  ...props
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center gap-2 px-8 py-4 text-lg font-extrabold text-black tracking-wide bg-[linear-gradient(180deg,#E6C24A_0%,#C9A227_45%,#8C6D1A_100%)] ring-1 ring-gold/50 rounded-full shadow-[0_8px_30px_rgba(201,162,39,0.4),inset_0_1px_0_rgba(255,255,255,0.45)] hover:shadow-[0_10px_40px_rgba(201,162,39,0.6),inset_0_1px_0_rgba(255,255,255,0.5)] transition-all duration-300 transform hover:scale-105';
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} data-id="element-39">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} {...props} data-id="element-40">
      {children}
    </motion.button>;
}